export default "<ng-container *ngIf=\"job$ | async as job\">\r\n  <app-job-viewer [job]=\"job\"></app-job-viewer>\r\n</ng-container>"